import { render, staticRenderFns } from "./submitApproval.vue?vue&type=template&id=12328a8f&scoped=true"
import script from "./submitApproval.vue?vue&type=script&lang=js"
export * from "./submitApproval.vue?vue&type=script&lang=js"
import style0 from "./submitApproval.vue?vue&type=style&index=0&id=12328a8f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12328a8f",
  null
  
)

export default component.exports